import React from "react";
import {CheckCircle, XCircle, Lock} from 'lucide-react';

function V1() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById("oferta");
    offerSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white text-black font-mono">
      {/* SEÇÃO 1 — HERO */}
      <section className="pt-20 pb-20 px-4 border-b-4 border-black">
        <div className="max-w-5xl mx-auto text-center">
          <div className="space-y-8">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight uppercase tracking-tight">
              Você não precisa aprender IA para ganhar dinheiro com ela.
            </h1>
            <div className="max-w-3xl mx-auto border-l-8 border-black pl-6">
              <p className="text-lg md:text-xl font-bold leading-tight text-left">
                Este ebook mostra como pessoas comuns estão usando IA para vender serviços simples, <span className="bg-yellow-400 border-2 border-black pt-[1px] pl-[4px] pr-[4px] pb-[1px]">mesmo sendo iniciantes</span> — sem aparecer, sem virar especialista e sem teoria infinita.
              </p>
            </div>
            <button
              onClick={scrollToOffer}
              className="bg-[#166534] hover:bg-[#14532d] text-white px-10 py-5 font-black uppercase text-base md:text-lg border-4 border-black transition-all hover:translate-x-2 hover:translate-y-2 inline-block text-center cursor-pointer">
              👉 Quero acessar o ebook agora
            </button>
          </div>
        </div>
      </section>

      {/* SEÇÃO 2 — IDENTIFICAÇÃO */}
      <section className="py-20 px-4 bg-black text-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase leading-tight mb-12">
            Se você já tentou alguma renda extra online, isso aqui pode soar familiar…
          </h2>
          <div className="space-y-6 text-lg md:text-xl font-bold">
            <div className="border-l-8 border-yellow-400 pl-6 py-2">
              Você já ouviu que "IA é o futuro", mas não sabe por onde começar
            </div>
            <div className="border-l-8 border-yellow-400 pl-6 py-2">
              Acha que precisa estudar demais antes de ganhar algo
            </div>
            <div className="border-l-8 border-yellow-400 pl-6 py-2">
              Já tentou curso, afiliado ou ideia mirabolante e travou
            </div>
            <div className="border-l-8 border-yellow-400 pl-6 py-2">
              Só queria algo simples que desse pra executar de verdade
            </div>
            <div className="border-l-8 border-yellow-400 pl-6 py-2">
              Até achou o que vender, mas não sabia por onde começar
            </div>
          </div>
          <div className="mt-12 bg-black text-yellow-400 p-8 border-4 border-yellow-400">
            <p className="text-xl md:text-2xl font-black uppercase">
              Se você se reconhece nisso, esse material foi feito pra você.
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 3 — REPOSICIONAMENTO */}
      <section className="py-20 px-4 border-b-4 border-black">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-12">
            O problema não é a IA. É tentar começar do jeito errado.
          </h2>
          <div className="bg-black text-white p-8 md:p-12 border-4 border-black space-y-6">
            <p className="text-xl md:text-2xl font-black uppercase">
              IA não é o produto.
            </p>
            <p className="text-xl md:text-2xl font-black">
              As pessoas não pagam por "IA".
            </p>
            <div className="border-t-4 border-yellow-400 pt-6 mt-6">
              <p className="text-lg md:text-xl font-bold mb-4">Elas pagam para:</p>
              <ul className="space-y-3 text-base md:text-lg font-bold">
                <li className="flex items-start gap-3">
                  <span className="text-yellow-400 text-2xl">→</span>
                  resolver um problema simples
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-yellow-400 text-2xl">→</span>
                  economizar tempo
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-yellow-400 text-2xl">→</span>
                  ter algo organizado e funcional
                </li>
              </ul>
            </div>
            <div className="border-t-4 border-white pt-6 mt-6">
              <p className="text-lg md:text-xl font-bold leading-relaxed">
                Neste ebook, a IA entra apenas como ferramenta.
                <span className="block mt-2">
                  Você aprende a organizar, ajustar e entregar serviços que já têm demanda hoje.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 4 — O QUE VOCÊ VAI CONSEGUIR FAZER */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-12">
            O que você vai conseguir colocar em prática
          </h2>
          
          <div className="border-4 border-black p-8 md:p-12 mb-12 bg-yellow-400">
            <p className="text-lg md:text-xl font-bold mb-6">Com este ebook, você vai aprender a:</p>
            <ul className="space-y-4 text-base md:text-lg font-bold">
              <li className="flex items-start gap-3">
                <span className="text-2xl">▪</span>
                Escolher UM serviço simples para começar
              </li>
              <li className="flex items-start gap-3">
                <span className="text-2xl">▪</span>
                Pedir as informações que precisa ao cliente
              </li>
              <li className="flex items-start gap-3">
                <span className="text-2xl">▪</span>
                Criar esse serviço usando IA, mesmo sendo iniciante
              </li>
              <li className="flex items-start gap-3">
                <span className="text-2xl">▪</span>
                Entregar algo útil e profissional
              </li>
              <li className="flex items-start gap-3">
                <span className="text-2xl">▪</span>
                Cobrar por isso
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <p className="text-xl md:text-2xl font-black uppercase mb-8">
              Exemplos reais de serviços ensinados:
            </p>
            <div className="grid md:grid-cols-2 gap-4">
              {[
              "Cardápio digital com QR Code",
              "Bio profissional para Instagram",
              "Site simples para negócios locais",
              "Respostas prontas para WhatsApp",
              "Materiais prontos de divulgação",
              "Landing page básica focada em vendas"].
              map((item, index) =>
              <div key={index} className="border-[6px] border-black p-6 bg-gray-50 hover:bg-yellow-400 transition-colors">
                  <p className="font-black text-base uppercase">{item}</p>
                </div>
              )}
            </div>
          </div>

          <div className="bg-black text-white p-8 border-4 border-black">
            <p className="text-xl md:text-2xl font-black uppercase text-center">Nada de teoria. Tudo aplicado e orientado

            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 5 — PROVA SOCIAL */}
      <section className="py-20 px-4 bg-black text-white border-t-4 border-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-12">
            Gente comum executando coisas simples
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="border-4 border-white bg-white p-2">
              <img
                src="https://static.lumi.new/b1/b11265f02d7d69dfc4c248fe857c8f67.png"
                alt="Depoimento Cibele - WhatsApp"
                className="w-full" />
            </div>
            <div className="border-4 border-white bg-white p-2">
              <img
                src="https://static.lumi.new/fd/fd8b31bf857ae9d8474c0a7dac2da33b.png"
                alt="Depoimento João - WhatsApp"
                className="w-full" />
            </div>
            <div className="border-4 border-white bg-white p-2">
              <img
                src="https://static.lumi.new/17/17e4f8f4155b3951fb8c6c2e9eec24ce.png"
                alt="Depoimento Rodrigo - WhatsApp"
                className="w-full" />
            </div>
          </div>
          <div className="border-4 border-yellow-400 p-8">
            <p className="text-lg md:text-xl font-bold text-center mb-6">
              Pessoas que simplesmente aplicaram o passo a passo — sem virar expert, sem inventar moda.
            </p>
            <p className="text-base font-bold text-center text-yellow-400 border-t-4 border-yellow-400 pt-6">
              Mensagens reais de quem aplicou o passo a passo
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 6 — PARA QUEM É / NÃO É */}
      <section className="py-20 px-4 bg-white border-b-4 border-black">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-12 text-center">
            Este ebook é pra você?
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* É pra você */}
            <div className="border-4 border-black bg-yellow-400 p-8">
              <h3 className="text-2xl font-black uppercase mb-8 flex items-center gap-3">
                <CheckCircle size={36} strokeWidth={3} />
                É PRA VOCÊ SE:
              </h3>
              <ul className="space-y-4 text-base font-bold">
                {[
                "Quer uma renda extra possível",
                "Prefere algo simples e direto",
                "Não quer aparecer",
                "Quer aprender fazendo"].
                map((item, index) =>
                <li key={index} className="flex items-start gap-3 border-l-4 border-black pl-4 py-2">
                    {item}
                  </li>
                )}
              </ul>
            </div>

            {/* Não é pra você */}
            <div className="border-4 border-black bg-black text-white p-8">
              <h3 className="text-2xl font-black uppercase mb-8 flex items-center gap-3 underline decoration-4 decoration-yellow-400">
                <XCircle size={36} strokeWidth={3} />
                NÃO É PRA VOCÊ SE:
              </h3>
              <ul className="space-y-4 text-lg font-bold">
                {[
                "Procura dinheiro fácil",
                "Quer resultado automático",
                "Não pretende executar nada"].
                map((item, index) =>
                <li key={index} className="flex items-start gap-3 border-l-4 border-yellow-400 pl-4 py-2">
                    {item}
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="mt-8 border-4 border-black p-8 bg-white">
            <p className="text-2xl md:text-3xl font-black uppercase text-center">
              Esse material exige ação. Mesmo que simples.
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 7 — COMO FUNCIONA */}
      <section className="py-20 px-4 bg-yellow-400">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-12 text-center">
            O método é simples de propósito
          </h2>
          <div className="space-y-6">
            {[
            { num: "1", title: "Escolha um serviço" },
            { num: "2", title: "Siga os passos" },
            { num: "3", title: "Use os prompts prontos" },
            { num: "4", title: "Crie a entrega" },
            { num: "5", title: "Entregue" },
            { num: "6", title: "Receba" }].
            map((item, index) =>
            <div key={index} className="flex items-center gap-6 bg-black text-white p-6 border-4 border-black">
                <div className="bg-yellow-400 text-black font-black text-3xl w-20 h-20 flex items-center justify-center flex-shrink-0 border-4 border-white">
                  {item.num}
                </div>
                <p className="text-xl md:text-2xl font-black uppercase">{item.title}</p>
              </div>
            )}
          </div>
          <div className="mt-12 bg-black text-white p-8 border-4 border-black space-y-4">
            <p className="text-2xl md:text-3xl font-black uppercase">Sem funil complicado.</p>
            <p className="text-2xl md:text-3xl font-black uppercase">Sem "estratégia avançada".</p>
            <p className="text-2xl md:text-3xl font-black uppercase text-yellow-400">
              Simples porque funciona.
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 8 — O QUE VOCÊ RECEBE */}
      <section className="py-20 px-4 bg-white border-b-4 border-black">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-12">
            O que você recebe ao acessar
          </h2>
          <div className="border-4 border-black p-8 md:p-12 space-y-6">
            {[
            "Ebook digital completo",
            "10 serviços explicados passo a passo",
            "Prompts testados na prática (não são exemplos)",
            "Checklist de execução",
            "Plano de ação para os primeiros 7 dias"].
            map((item, index) =>
            <div key={index} className="flex items-start gap-4 border-l-8 border-black pl-6 py-3 hover:bg-yellow-400 transition-colors">
                <span className="text-3xl font-black">▪</span>
                <p className="text-xl md:text-2xl font-bold">{item}</p>
              </div>
            )}
          </div>
          <div className="mt-8 bg-black text-yellow-400 p-8 border-4 border-black">
            <p className="text-2xl md:text-3xl font-black uppercase text-center">
              Você não vai perder tempo testando prompt do zero. Tudo aqui já foi usado.
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 9 — OFERTA */}
      <section id="oferta" className="py-20 px-4 bg-black text-white">
        <div className="max-w-5xl mx-auto">
          <div className="border-4 border-white p-8 md:p-12 space-y-8">
            <p className="text-lg md:text-xl font-bold text-center">
              Esse material poderia ser vendido tranquilamente por R$47.
            </p>
            <p className="text-xl md:text-2xl font-black text-center">Para facilitar o SEU primeiro passo, o acesso hoje está por apenas:

            </p>
            
            <div className="bg-yellow-400 text-black p-12 border-4 border-white text-center">
              <p className="text-sm font-bold uppercase mb-2 opacity-60">De: R$47</p>
              <p className="text-5xl md:text-7xl font-black uppercase leading-none mb-4">R$27</p>
              <p className="text-lg font-black uppercase border-t-4 border-black pt-4">ACESSO IMEDIATO + 3 BÔNUS EXCLUSIVOS NO EBOOK

              </p>
            </div>

            <p className="text-lg font-bold text-center">
              Menos do que errar tentando sozinho mais uma vez.
            </p>

            <a
              href="https://pay.kiwify.com.br/j0HCPzr"
              target="_blank"
              rel="noopener noreferrer"
              className="go-to-checkout bg-[#166534] hover:bg-[#14532d] text-white px-12 py-6 font-black uppercase text-lg md:text-xl border-4 border-white transition-all hover:translate-x-2 hover:translate-y-2 w-full inline-block text-center">
              👉 Quero acessar agora
            </a>

            <div className="flex items-center justify-center gap-3 border-t-4 border-white pt-6">
              <Lock size={24} strokeWidth={3} />
              <span className="font-bold uppercase text-sm">Pagamento 100% seguro | 7 dias de garantia</span>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 10 — CTA FINAL */}
      <section className="py-20 px-4 bg-yellow-400 border-b-4 border-black">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          <h2 className="text-3xl md:text-5xl font-black uppercase leading-tight">
            Não é sobre aprender IA.
          </h2>
          <p className="text-2xl md:text-3xl font-black uppercase">
            É sobre usar a IA para vender algo simples — do jeito mais direto possível.
          </p>
          <button
            onClick={scrollToOffer}
            className="bg-black hover:bg-gray-900 text-[#166534] px-12 py-6 font-black uppercase text-lg md:text-xl border-4 border-black transition-all hover:translate-x-2 hover:translate-y-2 inline-block cursor-pointer">
            👉 Acessar o ebook agora
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12 px-4 border-t-4 border-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div className="border-l-4 border-yellow-400 pl-6">
              <h3 className="font-black text-lg uppercase mb-4">Começar com IA</h3>
              <p className="font-bold text-sm">
                Ebook prático para quem quer gerar renda extra usando IA como ferramenta.
              </p>
            </div>
            <div className="border-l-4 border-yellow-400 pl-6">
              <h3 className="font-black text-lg uppercase mb-4">Contato</h3>
              <p className="font-bold text-sm">contato@comecarcomia.online</p>
              
            </div>
            <div className="border-l-4 border-yellow-400 pl-6">
              <h3 className="font-black text-lg uppercase mb-4">Legal</h3>
              <ul className="space-y-2 text-sm font-bold">
                <li><a href="#" className="hover:text-yellow-400 transition-colors uppercase">Privacidade</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors uppercase">Termos</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors uppercase">Reembolso</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t-4 border-white pt-8 text-center">
            <p className="font-black uppercase text-sm">© 2026 Começar com IA</p>
            <p className="mt-2 flex items-center justify-center gap-2 font-bold text-sm">
              <Lock size={14} strokeWidth={3} />
              SITE SEGURO
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default V1;